import { ButtonNorlys } from '~src/components/Button';

import { NavigationButtonsWrapperNorlys } from '../style';
import { NavigationButtonsProps } from '../types';
import { scrollToStage } from '../util';

export const NavigationButtonsNorlys = ({
  stepKeys,
  stage,
  setStage,
  lastStepIndex,
  enabled = true,
  onFinish,
  lastStepButtonText,
}: NavigationButtonsProps) => {
  const isLastStep = stage === lastStepIndex;

  return (
    <NavigationButtonsWrapperNorlys>
      <ButtonNorlys
        {...{
          disabled: !enabled,
          size: 'middle',
          onClick: event => {
            event.stopPropagation();
            isLastStep ? onFinish?.() : setStage(stage + 1);
            scrollToStage(stepKeys, stage + 1);
          },
        }}
      >
        {isLastStep ? lastStepButtonText : 'gå videre'}
      </ButtonNorlys>
    </NavigationButtonsWrapperNorlys>
  );
};
